import type { IState } from '@/Module/Store/Model';
import { subscriptionsV2UserAdapter, transactionUserAdapter } from '@/Module/Subscription/Store/Adapter';

export const { selectAll: subscriptionsV2UserSelectAll } = subscriptionsV2UserAdapter.getSelectors<IState>(
  state => state.subscription.subscriptionsV2User,
);
export const { selectById: transactionUserSelectById, selectIds: transactionUserSelectIds } =
  transactionUserAdapter.getSelectors<IState>(state => state.subscription.transactionUser);
